var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAdmin
    ? _c("ResourcesListCard", {
        attrs: {
          getRoleAdmin: _vm.isAdmin,
          contractor: _vm.contractor,
          companyId: _vm.company.id,
          currentUser: _vm.currentUser,
          userUpdatedDate: _vm.userUpdatedDate,
          currentUserId: _vm.currentUser.id,
        },
        on: {
          cardDataUpdated: function ($event) {
            return _vm.$emit("cardDataUpdated")
          },
        },
      })
    : _c("CompanyContractorManagerCard", {
        attrs: {
          getRoleAdmin: _vm.isAdmin,
          user: _vm.contractor.user,
          contractor: _vm.contractor,
          companyId: _vm.company.id,
          currentUser: _vm.currentUser,
          hasAllResourceAccess: _vm.hasAllResourceAccess,
          userUpdatedDate: _vm.userUpdatedDate,
          currentUserId: _vm.currentUser.id,
        },
        on: {
          cardDataUpdated: function ($event) {
            return _vm.$emit("cardDataUpdated")
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }